module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-002.ab13bf58.png";